import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { trips } from "../../../../../../redux/trips/action";
import { selectTripsListItems } from "../../../../../../redux/trips/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import { agentStatus } from "../../../../../../redux/agent-status/action";
import { paymentStatus } from "../../../../../../redux/payment-status/action";

const ManagementTrips = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const libraryData = useSelector(selectListItems)
    const [pageSize, setPageSize] = useState(10);
    const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectTripsListItems)
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: `fulfillments[0].start.location`, headerName: 'Pickup Address', isAddressFormat: true },
            { field: `fulfillments[0].end.location`, headerName: 'Drop Address', isAddressFormat: true },
            { field: `fulfillments[0].vehicle.vehicleType`, headerName: 'VehicleType', searchField: 'fulfillments[0].vehicle.vehicleType', sortable: true, filter: true, filterType: 'text' },
            {
                field: 'PaymentMethodId',
                headerName: 'Payment Method',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.PaymentMethod },
                isRowColorDecider: true,
                sortable: true,
                filter: false
            },
            {
                field: 'PaymentStatusId',
                headerName: 'Payment Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.PaymentStatus },
                sortable: true,
                filter: false,
                isPaymentEditble: true, isRowColorDecider: true
            },
            {
                field: `CargoTripsStatusId`, headerName: 'Trip status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTripsStatus }, isRowColorDecider: true,
            },
            {
                field: `CargoOrderStatusId`, headerName: 'Order Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoOrderStatus }, isCargoOrderEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoTransportAgentStatusId`, headerName: 'Driver Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTransportAgentStatus }, isCargoDriverEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoPickupStatusId`, headerName: 'Pickup Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoPickupStatus }, isCargoPickupEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoExceptionOrIssuesStatusId`, headerName: 'Exceptions/Issues Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoExceptionOrIssuesStatus }, isCargoIssuesEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoTransitStatusId`, headerName: 'Transit Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTransitStatus }, isCargoTransitEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoDeliveryStatusId`, headerName: 'Delivery Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoDeliveryStatus }, isCargoDeliveryEditable: true, isRowColorDecider: true
            },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }


    const fetchTrips = () => {
        dispatch(trips.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",


            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchTrips()
    }, [pageData, pageSize])

    const handleDelete = (data: any) => {
        dispatch(trips.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/delete`,
            entity: 'trips',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchTrips()

        });
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
    }
    const handleReloadData = () => {
        fetchTrips()
    }
    const additionButtons: any = [

        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "fulfillments[0].vehicle.vehicleType",
                FieldText: "fulfillments[0].vehicle.vehicleType",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(trips.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`,
            entity: 'trips',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    }

    const handleCargoDriverStatusClick = async (event: any, data: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/agent-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.fulfillments[0]?.agent?.id,
                        "TripsId": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "CargoTransportAgentStatusId": event
                    }
                ]

            }
        })).then(() => {
            dispatch(trips.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }));
        });
    };
    const handleCargoDeliveryStatusClick = async (event: any, data: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/delivery-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.fulfillments[0]?.agent?.id,
                        "TripsId": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "CargoDeliveryStatusId": event
                    }
                ]

            }
        })).then(() => {
            dispatch(trips.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }));
        });
    };
    const handleCargoTransitStatusClick = async (event: any, data: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/transit-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.fulfillments[0]?.agent?.id,
                        "TripsId": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "CargoTransitStatusId": event
                    }
                ]

            }
        })).then(() => {
            dispatch(trips.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }));
        });
    };
    const handleCargoIssueStatusClick = async (event: any, data: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/issue-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.fulfillments[0]?.agent?.id,
                        "TripsId": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "CargoExceptionOrIssuesStatusI": event
                    }
                ]

            }
        })).then(() => {
            dispatch(trips.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }));
        });
    };
    const handleCargoPickupStatusClick = async (event: any, data: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/pickup-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.fulfillments[0]?.agent?.id,
                        "TripsId": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "CargoPickupStatusId": event
                    }
                ]

            }
        })).then(() => {
            dispatch(trips.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }));
        });
    };

    const handleAgentAssignSubmit = async (event: any, data: any, agentId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "CargoOrderStatusId": event,
                    }
                ]

            }
        }))
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/assign-agent`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": data?.Id,
                        "ShipmentId": data?.ShipmentId,
                        "AgentId": agentId,
                    }
                ]

            }
        })).then(() => {
            dispatch(trips.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }));
        });
    }

    const handlePaymentStatusClick = async (paymentValue: any, dataId: any) => {
        await dispatch(paymentStatus.resetAction({ actionType: 'update' }))
        await dispatch(paymentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/payment-status`,
            entity: 'paymentStatus',
            jsonData: {


                Records: [
                    {
                        context: {},
                        Message: {
                            ShipmentId: dataId?.ShipmentId,
                            PaymentStatusId: paymentValue?.PaymentStatusId,
                            PaidAmount: paymentValue?.PaidAmount
                        }
                    }
                ]


            }
        }))
        await fetchTrips()
    }



    return (
        <>
            {itemsData?.isLoading ? <PageLoader />
                :
                <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
                    enableFilter={true} onSearch={handleSearch} onPaymentStatusClick={handlePaymentStatusClick} onAgentAssignClick={handleAgentAssignSubmit} onCargoDriverStatusClick={handleCargoDriverStatusClick} onCargoDeliveryStatusClick={handleCargoDeliveryStatusClick} onCargoTransitStatusClick={handleCargoTransitStatusClick} onCargoIssueStatusClick={handleCargoIssueStatusClick} onCargoPickupStatusClick={handleCargoPickupStatusClick} additionButtons={additionButtons} paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} headingName="Trips" />
            }
        </>

    );
};

export default ManagementTrips;


